export default __webpack_public_path__ + "static/media/completed-quiz.002bcee5.svg";